import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';
import FmdBadRoundedIcon from '@mui/icons-material/FmdBadRounded';
import { Box, Tooltip } from '@mui/material';
import { amber } from '@mui/material/colors';
import React from 'react';
import ErrorBoundary from '../errors/ErrorBoundary';
import InternalServerError from '../errors/InternalServerError.jsx';

const selectIconBasedOnEventType = (eventTypeCode, props) => {
  const icons = {
    NOTE_MENTION: (
      <AlternateEmailIcon sx={{ color: 'cornflowerblue' }} {...props} />
    ),
    SCHEDULED_TASK: <AccessAlarmIcon sx={{ color: amber[800] }} {...props} />,
    REFUND_ACCEPTED: <EuroSymbolIcon sx={{ color: 'green' }} {...props} />,
    REFUND_DONE: <EuroSymbolIcon sx={{ color: 'green' }} {...props} />,
    REFUND_PENDING: <EuroSymbolIcon sx={{ color: 'orange' }} {...props} />,
    REFUND_BLOCKED: <EuroSymbolIcon sx={{ color: 'red' }} {...props} />,
    REFUND_REFUSED: <EuroSymbolIcon sx={{ color: 'red' }} {...props} />,
    REFUND_FAILED: <EuroSymbolIcon sx={{ color: 'red' }} {...props} />,
  };

  return icons[eventTypeCode] || <FmdBadRoundedIcon {...props} />;
};

const EventTypeIcon = ({ eventType, ...props }) => {
  // ✅ CORRECTION : Vérification de sécurité pour eventType
  if (!eventType) {
    return (
      <ErrorBoundary fallback={<InternalServerError />} source="EventTypeIcon">
        <Tooltip placement="top" title="Événement inconnu">
          <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <FmdBadRoundedIcon {...props} />
          </Box>
        </Tooltip>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary fallback={<InternalServerError />} source="EventTypeIcon">
      <Tooltip
        placement="top"
        title={`${eventType?.name || 'Événement inconnu'}`}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          {selectIconBasedOnEventType(eventType.code, props)}
        </Box>
      </Tooltip>
    </ErrorBoundary>
  );
};

export default EventTypeIcon;
